module.exports = __webpack_public_path__ + "img/ars-logo-bw.20607721.png";